// Return on a held item if it were listed at the current Jita lowest sell, after fees.
// Only units with a cost basis (recorded purchases, or a manual cost) are valued.
export function investmentReturn(item, sellRevenueMultiplier) {
  if (item.avg_cost == null || item.jita_sell == null) return null;
  const netUnit = item.jita_sell * sellRevenueMultiplier;
  const cost = item.avg_cost * item.basis_qty;
  const value = netUnit * item.basis_qty;
  return {
    netUnit,
    cost,
    value,
    isk: value - cost,
    pct: cost ? (value - cost) / cost * 100 : null,
  };
}

export function investmentTotals(rows) {
  const valued = rows.filter(r => r.ret);
  const cost = valued.reduce((sum, r) => sum + r.ret.cost, 0);
  const value = valued.reduce((sum, r) => sum + r.ret.value, 0);
  return { cost, value, isk: value - cost, pct: cost ? (value - cost) / cost * 100 : null };
}

// Where the Jita sell sits in the 90-day range of daily averages: 0 = low, 100 = high.
// Can fall outside 0-100 when today's price breaks the range.
export function rangePosition(item) {
  const { range_low: low, range_high: high, jita_sell: price } = item;
  if (low == null || high == null || price == null || high <= low) return null;
  return (price - low) / (high - low) * 100;
}

// Return % spread over the average days the recorded units have been held.
export function returnPerDay(item, ret) {
  if (ret?.pct == null || item.avg_age_days == null || item.avg_age_days < 1) return null;
  return ret.pct / item.avg_age_days;
}
